import { ReactNode } from 'react';
import { useRequestsData } from './useData';
import { RequestsContext } from './RequestsContextObject';

export const RequestDataProvider = ({ children }: { children: ReactNode }) => {
  const {
    requests,
    loading,
    error,
    refreshRequests,
    getRequestById,
    addRequest,
    updateRequest,
    updateRequestStatus,
    deleteRequest,
  } = useRequestsData();

  return (
    <RequestsContext.Provider
      value={{
        requests,
        loading,
        error,
        refreshRequests,
        getRequestById,
        addRequest,
        updateRequest,
        updateRequestStatus,
        deleteRequest,
      }}
    >
      {children}
    </RequestsContext.Provider>
  );
};
